// @flow
import CustomLoader from "../customLoader";

export const CustomButton = ({
  title,
  onClick,
  loading,
  disabled,
  styles,
  textStyles,
  backgroundColor,
  loginButton,
  dataTestId = "button",
  icon,
  ionDirection = "left",
  mobileViewBtn,
  onKeyDown,
  buttonLoader = 20,
  buttonTitle = "",
}) => {
  return (
    <button
      title={buttonTitle}
      data-testid={dataTestId}
      style={{
        backgroundColor:
          disabled || loading
            ? "lightgrey"
            : backgroundColor
            ? backgroundColor
            : "#3783FB",
        borderRadius: 8,
        alignSelf: "center",
        padding: 6,
        cursor: !disabled ? "pointer" : "not-allowed",
        minWidth: loginButton ? 304 : 80,
        border: `0px solid ${
          disabled || loading ? "lightgrey" : backgroundColor
        }`,
        outline: "none",
        height: 40,
        width: mobileViewBtn ? 120 : 150,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...styles,
      }}
      disabled={loading || disabled ? true : false}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <div
        style={{
          marginLeft: 5,
          alignSelf: "center",
          marginRight: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {ionDirection === "left" && (
          <div
            style={{
              marginRight: 5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {icon && <img src={icon} alt="icon" style={{}} />}{" "}
          </div>
        )}
        {loading ? (
          <CustomLoader size={buttonLoader} />
        ) : (
          <p
            style={{
              fontSize: mobileViewBtn ? 12 : 14,
              cursor: "pointer",
              color: disabled ? "grey" : "white",
              padding: 0,
              margin: 0,
              fontWeight: "normal",
              alignSelf: "center",
              cursor: !disabled ? "pointer" : "not-allowed",

              ...textStyles,
            }}
            className="roboto"
          >
            {title}
          </p>
        )}
        {ionDirection === "right" && (
          <div
            style={{
              marginLeft: 5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            {icon && icon}{" "}
          </div>
        )}
      </div>
    </button>
  );
};
